<template>
  <div
    class="spread-item clearfix"
    :class="content.class"
  >
    <div
      class="item1 item-content"
      :class="imgPosition === 'left' ? 'right' : 'left'"
    >
      <div>
        <h2 class="title">
          {{ content.title }}
        </h2>
        <ul class="desc-list origin-list">
          <li
            v-for="item in content.desc"
            :key="item"
          >
            {{ item }}
          </li>
        </ul>
        <slot name="btn-w" />
      </div>
    </div>
    <div
      class="item1 item-pic"
      :class="imgPosition === 'left' ? 'left' : 'right'"
    >
      <img :src="content.pic_url">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgPosition: String,
    content: Object
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
.spread-item {
  height: 200px;
  position: relative;
  .item-content {
    width: 320px;
    padding-left: 35px;
    box-sizing: border-box;
    padding-top: 43px;
    line-height: 1;
    font-size: 14px;
  }
  .item-content.right {
    padding-left: 28px;
    left: 360px;
    .desc {
      padding-right: 69px;
      box-sizing: border-box;
    }
  }
  .left {
    position: absolute;
    left: 0;
    top: 0;
  }
  .right {
    position: absolute;
    left: 320px;
    top: 0;
  }
}
.title {
  color: #575757;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 20px;
}
.item-pic {
  width: 360px;
  &.right {
    text-align: center;
  }
  img {
    width: 90%;
    height: 90%;
  }
}
.desc-list {
  li {
    margin-bottom: 8px;
    line-height: 1;
    color: #797979;
  }
}
.origin-list {
  list-style: disc;
  padding-left: 25px;
  li {
    list-style: disc;
  }
}
</style>
